import React, { useContext, useState, useEffect } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';
import { Redirect } from 'react-router-dom';
import ENDPOINT from '../../../globals/api-endpoint';
import styled from 'styled-components';
import UserServices from './UserServices';
import UserProjects from './UserProjects';
import UserInfo from './UserInfo';

const H3 = styled.h3`
	text-align: center;
	margin-top: 20px;
`;

const UserProfile = (props) => {
	useEffect(() => {
	  window.scrollTo(0, 0)
	}, []);
	
	const userId = props.match.params.userId;
	const { auth, dispatch } = useContext(AuthContext);
	const [token, setToken] = useState({
		authToken: localStorage.getItem('authToken')
	});
	const [isLoading, setIsLoading] = useState(true);
	const localToken = JSON.parse(token.authToken);
	const tokenFromStorage = localToken ? (localToken.token) : (null);

	useEffect(() => {
		setToken({
			authToken: localStorage.getItem('authToken')
		});
	}, []);

	useEffect(() => {
		const fetchData = () => { 
			setIsLoading(true);
			fetch(ENDPOINT.CHECK_AUTH, {
				headers: {
					Authorization: tokenFromStorage
				}
			})
			.then(res => res.json())
			.then(res => {
				if (res.message === 'Auth succesful') {
					dispatch({ type: 'SWITCH_AUTH', auth: true,  uid: res.userId });
				} else {
					dispatch({ type: 'SWITCH_AUTH', auth: false });
				}
			})
			.catch(err => {
				console.log(err);
			})
			.finally(res => {
				setIsLoading(false);
			});
		}
		fetchData();
	}, [dispatch, tokenFromStorage]);

	if(auth.uid === userId) {
		return <Redirect to={'/me'}/>
	}


	if (isLoading) {
		return(
			<div className="loading">
				<div className="sk-folding-cube">
				  <div className="sk-cube1 sk-cube"></div>
				  <div className="sk-cube2 sk-cube"></div>
				  <div className="sk-cube4 sk-cube"></div>
				  <div className="sk-cube3 sk-cube"></div>
				</div>
			</div>
		);
	} else {
		return(
			<div>
				<H3>Profil</H3>
				<UserInfo userId={userId}/>
				<UserProjects userId={userId}/>
				<UserServices userId={userId}/>
			</div>
		);
	}
}

export default UserProfile;